import { StateUtils } from '@spartacus/core';
import { JOIN_LOYALTY_PROGRAM_ENTITY } from '../user-state';

export const JOIN_LOYALTY_PROGRAM = '[CustomUser] Join loyalty program';
export const JOIN_LOYALTY_PROGRAM_SUCCESS = '[CustomUser] Join loyalty program success';
export const JOIN_LOYALTY_PROGRAM_FAIL = '[CustomUser] Join loyalty program fail';

export class JoinLoyaltyProgram extends StateUtils.LoaderLoadAction {
  readonly type = JOIN_LOYALTY_PROGRAM;

  constructor() {
    super(JOIN_LOYALTY_PROGRAM_ENTITY);
  }
}

export class JoinLoyaltyProgramSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = JOIN_LOYALTY_PROGRAM_SUCCESS;

  constructor() {
    super(JOIN_LOYALTY_PROGRAM_ENTITY);
  }
}

export class JoinLoyaltyProgramFail extends StateUtils.LoaderFailAction {
  readonly type = JOIN_LOYALTY_PROGRAM_FAIL;

  constructor() {
    super(JOIN_LOYALTY_PROGRAM_ENTITY);
  }
}

export type LoyaltyProgramActions = JoinLoyaltyProgram | JoinLoyaltyProgramSuccess | JoinLoyaltyProgramFail;
